// extracted by mini-css-extract-plugin
export default {"root":"IconJamIconsOutlineLogosYoutub_root__rEO9D","vector":"IconJamIconsOutlineLogosYoutub_vector__b5bm3","icon":"IconJamIconsOutlineLogosYoutub_icon__7z252"};